<template>
    <div v-if="visible" class="edit-client-tag-components">
        <el-dialog
            class="client-tag-dialog"
            :visible.sync="visible"
            :title="$t('Setting.tag')"
            left>
            <el-form
                ref="form"
                :data="tag"
                :status-icon="true"
                label-position="right"
                label-width="130px"
                label-suffix=":">
                <el-form-item prop="name" :label="$t('Setting.Tag.name')">
                    <el-input
                        v-model="tag.name"
                        :placeholder="$t('Setting.Tag.fill_name')">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirm" type="primary">{{ $t('Common.submit') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog} from 'element-ui';

export default {
    name: 'edit-tag',
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            tag: {
                name: '',
            },
            id: null,
            name: '',
        };
    },
    created() {
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            // 清空form数据
            this.$refs.form.resetFields();
            this.tag.name = '';
        },
        open(id) {
            this.visible = true;
            this.id = Number(id);
            if (this.id) {
                this.fetchData();
            }
        },
        fetchData() {
            API.get(`client-tag/${this.id}`).then(res => {
                this.tag = res;
            });
        },
        confirm() {
            if (this.id) {
                API.put(`client-tag/${this.id}`, this.tag)
                    .then(res => {
                        if (res) {
                            $ele.$message.success(this.$t('Setting.Tag.edit_success'));
                            this.$emit('fetchData');
                        }
                        this.visible = false;
                    });
            } else {
                API.post('client-tag', this.tag)
                .then(res => {
                    if (res) {
                        $ele.$message.success(this.$t('Setting.Tag.add_success'));
                        this.$emit('fetchData');
                    }
                    this.visible = false;
                });
            }
        },
    },
};
</script>

<style lang="scss">
.edit-client-tag-components {
    .el-dialog {
        width: 540px;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 65px 0 25px;
    }
}
</style>
